<div class="assignment-attach-file">
  <label *ngIf="showLabel" class="control-label">{{fileLabel}}</label>
  <input data-classbutton="browse-button" (change)="UploadFile($event,FileUploadDetail);"
    class="form-control filestyle-1" data-input="false" data-text="Browse file" id="{{tempFilePath}}"
    style="position: absolute; clip: rect(0px, 0px, 0px, 0px);" type="file" accept="{{AcceptedFileType}}">
  <div class="bootstrap-filestyle input-group">
    <span class="group-span-filestyle " tabindex="0">
      <label for="{{tempFilePath}}" class="btn btn-default ">
        <span class="icon-span-filestyle glyphicon glyphicon-folder-open"></span>
        <span class="buttonText">{{bs.getResource('rbKey_Gmfctn_ChsFlLBL')}}</span>
      </label>
    </span>
  </div>
  <div class="assignment-attach-file-info">
    <div class="progress-bar-div">
      <div class="pro-bar">
        <div class="pro-bar-inn" [style.width]="FileUploadDetail['FileProgess']+'%'"></div>
      </div>
    </div>
    <br>
    <span class="fileUploadFormat">{{FileUploadDetail['FileName']}}</span>
    <span *ngIf="FileSize()"
      class="fileUploadSize">{{bs.getResource('rbkey_FlSzMSG')}}{{FileUploadDetail['FileSize']}}</span>

  </div>
  <div class="assignment-attach-file-validation" *ngIf="IsFileUploadTokenExpired()">
    {{bs.getResource('rbkey_InvldFlUpldRvstLBL')}}
  </div>
  <div class="assignment-attach-file-validation" *ngIf="IsVirusInfectedFile()">
    {{bs.getResource('rbkey_VrsFlMSG')}}
  </div>
  <div class="assignment-attach-file-validation" *ngIf="IsValidFileName()">
    {{bs.getResource('rbkey_SpclChrctrFlMSG')}}
  </div>
  <div class="assignment-attach-file-validation" *ngIf="IsValidFileType()">
    {{bs.getResource('rbkey_FlTypNtAllwMSG')}}
  </div>
  <div class="assignment-attach-file-validation" *ngIf="IsValidFileLength()">
    {{bs.getResource('rbkey_FlNmLngthMSG1')}}
  </div>
  <div class="assignment-attach-file-validation" *ngIf="IsInvalidFileSize">
    {{bs.getResource('rbkey_FlToLrgMSG')}}
  </div>

  <div class="assignment-attach-file-note">
    <!-- Note: <br>
    - Maximum file size for upload is {{AllowFileSize}}mb<br>
    - File formats allowed are:<br>
      {{AllowFileType}} -->
    {{bs.getResource('rbkey_NtLBL')}}: <br>
    -{{bs.getResource('rbkey_MxmmSzMSG')}}&nbsp;{{AllowFileSize}} {{bs.getResource('rbkey_MBLbl')}}<br>
    - {{bs.getResource('rbkey_FlUpldMsg')}}:<br>
    <div class="span-filetype" [innerHTML]="AllowFileType"> </div>
    {{ImgAspectRatio}}<br>
  </div>
  <input id="{{encryptedFilePath}}" value="{{FileUploadDetail['SaveFilePath']}}" type="hidden">
  <input id="{{fileSize}}" value="{{FileUploadDetail['FileSize']}}" type="hidden">
</div>
<a href="javascript:void(0);" (click)="openFile(ImgPath)"><img *ngIf="showImage" class="img_Signature" src="{{ImgPath}}" alt=""/></a>
